import { Helpers } from '../../helpers';
import { IProjectEstimate } from '../../interfaces/iproject-estimate';
import { Employee } from '../employee';
import { Project } from '../project';
import { ProjectAttachmentType } from '../project-attachment-type';
import { ProjectCostCodeCostTypeItemsRevision } from '../project-cost-code-cost-type-items-revision';
import { ProjectEstimatePhaseStepDetail } from '../project-estimate-phase-step-detail';
import { ProjectEstimateStatus } from '../project-estimate-status';
import { ProjectResourceItemsRevision } from '../project-resource-items-revision';
import { RecordType } from '../record-type';
import { StandardConfiguration } from '../standard-configuration';

export class ProjectEstimateBase {
  ProjectEstimateId: number;
  ProjectId: number | null;
  EstimateVersion: number | null;
  ProjectEstimateStatusId: number | null;
  EstimateTotal: number | null;
  EstimateDate: Date | null;
  CreatorId: number | null;
  Workflow: string | null;
  AFENumber: string | null;
  AFEVersion: string | null;
  AfeVersionDocumentId: string | null;
  RecordStatus: string | null;
  Record: string | null;
  RecordDescription: string | null;
  RecordApproverId: number | null;
  RecordApprovalDate: Date | null;
  RecordRevision: number | null;
  CreateDate: Date | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  ProjectAttachmentTypeId: number | null;
  Contingency: number | null;
  Tax: number | null;
  WasAFEResent: boolean;
  RecordTypeId: number | null;
  SysStartTime: Date;
  SysEndTime: Date;
  IsForecastOverride: boolean;
  LockCalculatedItems: boolean;
  RecordCreatorId: number | null;
  IsTaxPercent: boolean;
  IsContingencyPercent: boolean;
  TaxCost: number | null;
  ContingencyCost: number | null;
  WorkflowTask: string;
  StandardConfigurationId: number | null;
  EngineVersion: number | null;

  ProjectCostCodeCostTypeItemsRevisions_ProjectEstimate?: Array<ProjectCostCodeCostTypeItemsRevision> | null;
  ProjectEstimatePhaseStepDetails_ProjectEstimate?: Array<ProjectEstimatePhaseStepDetail> | null;
  ProjectResourceItemsRevisions_ProjectEstimate?: Array<ProjectResourceItemsRevision> | null;
  ProjectAttachmentType?: ProjectAttachmentType;
  ProjectEstimateStatus?: ProjectEstimateStatus;
  Project?: Project;
  RecordType?: RecordType;
  Creator?: Employee;
  RecordApprover?: Employee;
  StandardConfiguration?: StandardConfiguration;

  constructor(item?: IProjectEstimate) {
    if (item) {

      this.ProjectEstimateId = item.ProjectEstimateId;
      this.ProjectId = item.ProjectId;
      this.EstimateVersion = item.EstimateVersion;
      this.ProjectEstimateStatusId = item.ProjectEstimateStatusId;
      this.EstimateTotal = item.EstimateTotal;
      this.EstimateDate = item.EstimateDate ? new Date(item.EstimateDate) : null;
      this.CreatorId = item.CreatorId;
      this.Workflow = item.Workflow;
      this.RecordStatus = item.RecordStatus;
      this.Record = item.Record;
      this.RecordDescription = item.RecordDescription;
      this.RecordApproverId = item.RecordApproverId;
      this.RecordApprovalDate = item.RecordApprovalDate ? new Date(item.RecordApprovalDate) : null;
      this.RecordRevision = item.RecordRevision;
      this.CreateDate = item.CreateDate ? new Date(item.CreateDate) : null;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.ProjectAttachmentTypeId = item.ProjectAttachmentTypeId;
      this.Contingency = item.Contingency;
      this.Tax = item.Tax;
      this.WasAFEResent = item.WasAFEResent;
      this.RecordTypeId = item.RecordTypeId;
      this.SysStartTime = item.SysStartTime ? new Date(item.SysStartTime) : null;
      this.SysEndTime = item.SysEndTime ? new Date(item.SysEndTime) : null;
      this.LockCalculatedItems = item.LockCalculatedItems;
      this.RecordCreatorId = item.RecordCreatorId;
      this.IsTaxPercent = item.IsTaxPercent;
      this.IsContingencyPercent = item.IsContingencyPercent;
      this.TaxCost = item.TaxCost;
      this.ContingencyCost = item.ContingencyCost;
      this.WorkflowTask = item.WorkflowTask;
      this.StandardConfigurationId = item.StandardConfigurationId;
      this.EngineVersion = item.EngineVersion;

      this.ProjectCostCodeCostTypeItemsRevisions_ProjectEstimate = Helpers.createClassArray(ProjectCostCodeCostTypeItemsRevision, item.ProjectCostCodeCostTypeItemsRevisions_ProjectEstimate);
      this.ProjectEstimatePhaseStepDetails_ProjectEstimate = Helpers.createClassArray(ProjectEstimatePhaseStepDetail, item.ProjectEstimatePhaseStepDetails_ProjectEstimate);
      this.ProjectResourceItemsRevisions_ProjectEstimate = Helpers.createClassArray(ProjectResourceItemsRevision, item.ProjectResourceItemsRevisions_ProjectEstimate);
      this.ProjectAttachmentType = new ProjectAttachmentType(item.ProjectAttachmentType);
      this.ProjectEstimateStatus = new ProjectEstimateStatus(item.ProjectEstimateStatus);
      this.Project = new Project(item.Project);
      this.RecordType = new RecordType(item.RecordType);
      this.Creator = new Employee(item.Creator);
      this.RecordApprover = new Employee(item.RecordApprover);
      this.StandardConfiguration = new StandardConfiguration(item.StandardConfiguration);
    }
  }
}